<template>
  <div class="container">
    <div class="img">
      <img src="../assets/image/关于我们.png" alt="关于我们" />
    </div>
    <div class="tit">
      <div @click="scrollToSection('company_introduce')">公司简介</div>
      <div @click="scrollToSection('organizational_structure')">组织架构</div>
      <div @click="scrollToSection('corporate_culture')">企业文化</div>
      <div @click="scrollToSection('qualification_certificate')">资质证书</div>
      <div @click="scrollToSection('after_sales_service_commitment_letter')">
        售后服务承诺书
      </div>
    </div>
    <div class="line"></div>

    <!-- 版心 -->
    <div class="gutter">
      <div class="tem">
        <div class="section" ref="company_introduce" id="section1">
          <strong>公司简介</strong>
        </div>
        <div class="content">
          <p>
            <strong>江苏君成智慧洁净科技有限公司</strong>
            起源于2014年,核心团队由一群从事受控环境(俗称洁净室)行业
            服务客户数十年人员组成,是一家以“智能硬件+物联网技术+智慧化管
            控平台+AIGC垂直大模型"为产品理念,聚焦于传感、物联、人工智能等核
            心技术,集研发、生产、营销、销售、服务于一体的品牌型国家级高新技术企业。
          </p>
          <p>
            公司以制药、军工、航天、半导体、光伏、芯片、精密电子、新能源、电子、医院、食品厂、实验室、新材料等一切使用洁净室的场景端为用户，
            坚持"做有意义的事,成就有意义人生"的企业价值观,追求产品极优化性能,服务范围主要有:检测、监测类智能仪器仪表、智能净化设备、空气环境实时监测解决方案、洁净室智慧管控平台(WisM)、无线信号传输模块、洁净室效能异常解决方案、智能产线及工厂、计量、信息数据运维等,涵盖感知、物联、传输、平台、应用等完整技术体系。
          </p>
          <p>
            公司在新技术、新产品开发等环节长久规划,有序投入,目前在数个方面已取得了重大突破：
          </p>
          <p>
            1、基于光散射原理的小粒径0.2um内的粒子检测技术达到一流水平,产品已取得国家计量院、中检(CCIC)的检测与认证,产品精准度及稳定性处于国内前沿;
          </p>
          <p>
            2、电力载波无线传输技术有效解决了洁净室内信号屏蔽、数据丢失的困扰难题;
          </p>
          <p>
            3、WisM洁净室智慧管控平台由十数名清华大学科学家团队开发,已初步实现客户的多系统并行、融合与关联数据分析、菜单式调试与管理,核心技术智能数据引擎,基于分布交叉校验的数据质控模型+高性能时空索引数据库+可迁移的数据驱动工具箱为主体架构,对用户端洁净室的能效改善、异常分析与解决方案实施、人力优化等价值意义重大。
          </p>
          <p>
            4、局部区域内小范围的电磁辐射工频和强度检测技术,更是填补细分领域的产品空白；
          </p>
          <p>
            自公司成立以来,先后取得了ISO质量体系认证企业、3A级信用企业、科技型中小企业、民营科技企业、高新技术企业、各类型行业协会资质、崇本人才,公司与清华大学、山东大学、江南大学、南理工及江海大、长光所等数所高校或科研团队企业结成战略供应、产学研及研究生实习基地等合作、战略伙伴关系,公司产品已经取得了CE认证,已取得发明、软著、商标注册权、实用新型等专利四十余项。保持日新月异的态势,走在引领行业、替代国外的发展快车道上。
          </p>
          <p>
            未来,公司将逐步、有序地赶超国外先进技术,以替代国外产品为目标,结合自身优势并围绕受控环境这个细分领域拓展、整合,围绕智能、智慧、物联、分析与应用、迭代、AIGC等概念来构建差异化竞争优势,立足多维度、多层次增值和共生体系建设。
          </p>
          <p>
            作为一家倡导数据服务,"智慧洁净室“场景服务的发起企业,公司始终坚持服务国家战略及民生安全,紧随经济结构调整下的智能制造、科技自强大趋势,以践行“让智慧存享”为使命,以实现“智慧洁净室数据服务商“为愿景而奋斗不已。
          </p>
        </div>
      </div>
      <div>
        <div class="section" ref="organizational_structure" id="section2">
          <strong>组织架构</strong>
        </div>
        <div class="or_img">
          <img src="../assets/image/组织架构.png" alt="组织架构" />
        </div>
      </div>

      <div style="margin-top: 14px">
        <div
          class="section"
          ref="corporate_culture"
          style="margin-top: 60px; margin-bottom: -12px"
          id="section3"
        >
          <strong>企业文化</strong>
        </div>
        <div class="total">
          <div class="total_top">
            <div class="corporate_mission">
              <div class="mission-text">企业使命</div>
              <div class="en_letter">Corporate mission</div>
            </div>
            <div class="corporate_vision">
              <div class="mission-text">企业愿景</div>
              <div class="en_letter">Corporate vision</div>
            </div>
          </div>

          <div class="corporate_values">
            <div class="mission-text">企业价值观</div>
            <div class="en_letter">Corporate values</div>
          </div>
        </div>
      </div>

      <div style="margin-top: 20px">
        <div class="section" ref="qualification_certificate" id="section4">
          <strong>资质证书</strong>
        </div>

        <!-- 资质证书 -->
        <!-- 轮播图 -->
        <div style="width: 100%; margin: 0 auto" class="hidden">
          <el-carousel :interval="4000" type="card" height="550px">
            <el-carousel-item
              v-for="(item, index) in items"
              :key="index"
              style="background-color: transparent"
            >
              <img :src="item.imageUrl" class="product-image" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="block">
          <el-carousel height="320px" class="product_center_block">
            <el-carousel-item
              v-for="(item, index) in items"
              :key="index"
              style="
                background-color: #fff;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
                justify-content: space-around;
              "
              ><img
                :src="item.imageUrl"
                class="product-image"
                style="margin: 0 auto"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div>
        <div
          class="section"
          ref="after_sales_service_commitment_letter"
          style="margin-top: 59px; margin-bottom: 37px"
          id="section5"
        >
          <strong>售后服务承诺书</strong>
        </div>
        <div class="book_bottom">
          <img src="../assets/image/售后服务承诺书.png" alt="售后服务承诺书" />
          <!-- <div class="book_left">
            <div class="eff">
              <p><strong>售后服务效率</strong></p>
              <div>
                <p>使用过程中出现产品故障，我们承诺：</p>
                <br />
                <p>“一”刻钟内响应到位</p>
                <p>“一”小时内回复服务规划 “一”天内给出服务/项目解决方案</p>
                <p>“一”周内解决既定问题</p>
              </div>
            </div>
            <div class="sta">
              <p><strong>售后服务标准</strong></p>
              <div>
                <p>非定制类产品，非人为因素导致的产品质量问题，我们承诺：</p>
                <p>“一”月内可退货</p>
                <br />
                <p>“一”年内可换货</p>
                <br />
                <p>“一”生保修服务</p>
                <p>非定制类产品，属于非质量问题的，我司提供有偿换货服务。</p>
              </div>
            </div>
          </div>
          <div class="book_right">
            <div class="lin_s">
              <div class="eff">
                <div style="text-align: center">
                  <strong>售后服务主体</strong>
                </div>
                <div>
                  <div>维修中心名称:江苏君成智慧洁净科技有限公司</div>
                  <div>
                    维修中心地址:江苏省苏州市吴江经济技术开发区云创路229号
                  </div>
                  <div>售后服务热线:18912720358</div>
                </div>
              </div>
              <div class="eff">
                <div style="text-align: center">
                  <strong>售后服务期限</strong>
                </div>
                <div>
                  <div>产品质保期十二个月，可提供有偿延保服务。</div>
                  <div>
                    在质保期内因产品本身质量原因造成的硬件损坏,我司提供免费维修和更换服务;
                  </div>
                  <div>
                    在质保期外产品的硬件损坏，按照收费标准收取更换的配件及服务费用。
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  mounted() {
    this.scrollToPosition();
  },
  watch: {
    "$route.query.scrollTo"(newVal) {
      this.scrollToPosition(newVal);
    },
  },
  data() {
    return {
      items: [
        {
          imageUrl: require("../assets/image/1智慧-洁净层流罩控制系统.jpg"),
        },
        {
          imageUrl: require("../assets/image/2智慧-洁净室环境监测APP软件.jpg"),
        },
        {
          imageUrl: require("../assets/image/3智慧-洁净室环境在线监测管理系统.jpg"),
        },
        {
          imageUrl: require("../assets/image/4智慧-在线浮游菌控制系统.jpg"),
        },
        {
          imageUrl: require("../assets/image/5智慧-在线粒子控制系统.jpg"),
        },
        // 其他仪器的名称和描述信息依此类推
      ],
    };
  },
  methods: {
    scrollToSection(sectionId) {
      // 获取对应内容块的引用
      const section = this.$refs[sectionId];
      if (section) {
        // 使用scrollIntoView方法滚动到内容块
        section.scrollIntoView({ behavior: "smooth" });
        // 可以在这里添加逻辑来显示小蓝线,例如设置一个data属性来控制样式
        // this.activeTab = sectionId;
      }
    },
    scrollToPosition(section = null) {
      let element = null;
      if (section) {
        element = document.querySelector(`#${section}`);
      } else {
        // 默认滚动到页面顶部
        element = document.body;
      }
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 966px) {
  .tit div,
  .img,
  .hidden {
    display: none; /* 隐藏所有.tit下的div元素 */
  }
}
@media (min-width: 966px) {
  .block {
    display: none;
  }
}
.tem {
  margin-bottom: 70px;
}
.lin_s {
  margin-right: 92px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  /* height: 400px; */
}
.product-image {
  width: 60%; /* 或者你需要的具体宽度 */
  height: auto;
  margin-bottom: 7px; /* 或者你需要的具体边距 */
  margin-top: 3px;
}
.eff {
  background-color: transparent;
  /* width: 85%; */
  text-align: left;
  margin: 0 auto;
  line-height: 30px;
  margin-left: 120px;
}
.sta {
  background-color: transparent;
  /* width: 88%; */
  text-align: left;
  margin: 0 auto;
  line-height: 30px;
  margin-left: 120px;
}
.book_right {
  width: 45%;
  background-color: #16abbe; /* 背景色 */
  height: auto;
  padding: 20px; /* 内边距 */
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.1); /* 更强的阴影效果 */
  background: linear-gradient(
    to bottom,
    #16abbe,
    #10899e
  ); /* 从上到下的渐变背景 */
  background-color: #16abbe; /* 背景色 */
  color: #fff;
  transition: box-shadow 0.3s ease; /* 添加阴影过渡效果 */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 18px;
  align-items: center;
}
.book_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 93%;
  margin: 0 auto;
  margin-bottom: 60px;
}
.book_left {
  background-image: url(../assets/image/七个一.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 45%;
  height: auto;
  padding: 20px; /* 内边距 */
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.1); /* 更强的阴影效果 */
  background-color: #1697be; /* 背景色 */
  color: #333;
  transition: box-shadow 0.3s ease; /* 添加阴影过渡效果 */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.en_letter {
  font-size: 20px;
}
.total_top {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 300px;
  margin-bottom: 40px;
}
.total_top div {
  width: 43%;
  background-repeat: no-repeat;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  border-radius: 10px; /* 圆角 */
}
.total {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  color: #fff;
  font-size: 24px;
}
/* 企业愿景 */
.corporate_vision {
  background-image: url(../assets/image/企业愿景.png);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  color: white; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
}
.corporate_vision .mission-text {
  font-size: 24px;
  color: white; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_vision:hover .mission-text {
  opacity: 0;
}

.corporate_vision:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

.corporate_vision .mission-text,
.corporate_vision .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

/* 鼠标悬停时隐藏企业使命和英文字母 */
.corporate_vision:hover .mission-text,
.corporate_vision:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}
/* 使用::before伪元素显示“企业使命” */
/* 使用::before伪元素显示悬停时的“企业使命” */
.corporate_vision::before {
  content: "企业愿景";
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 48px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid white; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

.corporate_vision::after {
  content: "智慧洁净室数据服务商";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 20px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_vision:hover::before,
.corporate_vision:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
/* 企业使命 */
.corporate_mission {
  background-image: url(../assets/image/企业使命.png);
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
}
/* 初始状态的企业使命文本 */
.corporate_mission .mission-text {
  font-size: 24px; /* 企业使命的字体大小 */
  color: white; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}
/* 鼠标悬停时隐藏原本的企业使命文本 */
.corporate_mission:hover .mission-text {
  opacity: 0;
}

.corporate_mission:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业使命和英文字母 */
.corporate_mission .mission-text,
.corporate_mission .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

/* 鼠标悬停时隐藏企业使命和英文字母 */
.corporate_mission:hover .mission-text,
.corporate_mission:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}
/* 使用::before伪元素显示“企业使命” */
/* 使用::before伪元素显示悬停时的“企业使命” */
.corporate_mission::before {
  content: "企业使命";
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 48px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid white; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 使用::after伪元素显示悬停时的“让智慧存享” */
.corporate_mission::after {
  content: "让智慧存享";
  position: absolute;
  top: calc(40% + 40px); /* 定位在“企业使命”下方 */
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 20px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_mission:hover::before,
.corporate_mission:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
/* // 企业价值观 */
.corporate_values {
  background-image: url(../assets/image/企业价值观.jpg);
  background-repeat: no-repeat;
  border-radius: 10px; /* 圆角 */
  width: 93%;
  margin: 0 auto;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  background-size: 100% 100%; /* 让背景图覆盖整个div */
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover; /* 让背景图覆盖整个div */
  background-position: center; /* 图像居中显示 */
  color: white; /* 假设文字颜色是白色，以便在背景图上清晰可见 */
  transition: background-color 0.5s ease; /* 添加背景色过渡效果 */
  /* 添加一个半透明的黑色背景，以便在鼠标悬停时使背景图变暗 */
  background-color: rgba(0, 0, 0, 0.3); /* 初始时就有一定的暗度 */
  position: relative;
  margin-bottom: 60px;
}
/* 初始状态的企业价值观文本 */
.corporate_values .mission-text {
  font-size: 24px; /* 企业价值观的字体大小 */
  color: white; /* 文本颜色 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}
/* 鼠标悬停时隐藏原本的企业价值观文本 */
.corporate_values:hover .mission-text {
  opacity: 0;
}

.corporate_values:hover {
  background-color: rgba(0, 0, 0, 1); /* 鼠标悬停时增加暗度 */
}

/* 初始状态下显示企业价值观和英文字母 */
.corporate_values .mission-text,
.corporate_values .en_letter {
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加透明度过渡效果 */
}

/* 鼠标悬停时隐藏企业价值观和英文字母 */
.corporate_values:hover .mission-text,
.corporate_values:hover .en_letter {
  opacity: 0; /* 鼠标悬停时隐藏 */
}
/* 使用::before伪元素显示“企业价值观” */
/* 使用::before伪元素显示悬停时的“企业价值观” */
.corporate_values::before {
  content: "企业价值观";
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  font-size: 48px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  border-bottom: 1px solid white; /* 底部白线 */
  padding-bottom: 5px; /* 白线与文本之间的间距 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 使用::after伪元素显示悬停时的“做有意义的事,成就有意义的人生” */
.corporate_values::after {
  content: "做有意义的事,成就有意义的人生";
  position: absolute;
  top: calc(40% + 40px);
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  font-size: 20px; /* 字体大小 */
  color: white; /* 文本颜色 */
  white-space: nowrap; /* 防止文本换行 */
  opacity: 0; /* 初始状态隐藏 */
  transition: opacity 0.5s ease; /* 透明度过渡效果 */
}

/* 鼠标悬停时显示两个伪元素 */
.corporate_values:hover::before,
.corporate_values:hover::after {
  opacity: 1; /* 鼠标悬停时显示 */
}
.img {
  height: 500px;
}
.img img {
  height: 500px;
}
.or_img img {
  width: 90%;
  height: auto;
}
p {
  text-indent: 2em;
  display: inline-block; /* 确保text-indent生效 */
  font-size: 18px;
}
.content strong {
  font-size: 18px;
}
.content {
  width: 90%;
  /* 设置卡片的宽度、边距、内边距等 */
  margin: 0 auto !important; /* 上下外边距20px，左右自动居中 */
  padding: 20px; /* 内边距 */
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  background-color: #1697be; /* 背景色 */
  color: #fff;
  transition: box-shadow 0.3s ease; /* 添加阴影过渡效果 */
  text-align: left;
}
.or_img {
  width: 93%;
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  background-color: #fff; /* 背景色 */
  transition: box-shadow 0.5s ease; /* 添加阴影过渡效果 */
  margin-bottom: 40px;
  margin: 0 auto;
}
.section {
  position: relative; /* 确保伪元素可以相对于这个元素定位 */
  display: inline-block; /* 确保元素的宽度与其内容相匹配 */
  color: #333; /* 文本颜色 */
  padding-bottom: 3px; /* 为下面的线留出空间 */
  margin-bottom: 20px;
  font-size: 20px;
}
.section::after {
  content: ""; /* 伪元素的内容为空 */
  position: absolute; /* 绝对定位 */
  left: 0; /* 从左侧开始 */
  bottom: 0; /* 在元素底部 */
  height: 2px; /* 线的高度 */
  width: 100%; /* 线的宽度与元素宽度相同 */
  background-color: blue; /* 线的颜色 */
}
.gutter {
  width: 88%;
  /* // background-color: pink; */
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.tit {
  display: flex;
  flex-direction: row;
  width: 50%;
  margin: 0 auto;
  justify-content: space-around;
  font-size: 20px;
  margin-top: 60px;
  div {
    cursor: pointer;
    &:hover {
      color: blue;
    }
    &.active {
      border-bottom: 2px solid blue;
    }
  }
}
</style>
